/*
  Authenticated Roles
 */
export const SELLING_AGENT_ROLE = "SellingAgent";
export const SELLING_AGENT_AUTHORIZER_ROLE = "SellingAgentAuthorizer";
export const ADCU_ROLE = "AdminADCU";
export const ISSUER_ROLE = "Issuer";
export const UNDERWRITER_ROLE = "Underwriter";
export const INVESTOR_ROLE = "Investor";
export const BROKER_ROLE = "Broker";
export const ADMIN_SPU_ROLE = 'AdminSPU';
export const ADMIN_LISTING_OFFICER = 'AdminListingOfficer';

export const ADCU_CHECKER = 'AdcuChecker';
export const ADCU_MAKER = 'AdcuMaker';

export const CA_CHECKER = 'CAChecker';
export const CA_MAKER = 'CAMaker';

export const RR_MAKER = 'RRMaker';
export const RR_CHECKER = 'RRChecker';

export const SELLING_AGENT_REPORT = 'SellingAgentReport'

/*
  Security Statuses
 */
export const SECURITY_ONGOING = '0';
export const SECURITY_SUBMITTED = '1';
export const SECURITY_AUTHORIZED = '2';

/*
  security offer reject
*/
export const SECURITY_ADCU_REJECTED = '3'

/*
  ATP Archiving Statuses
*/
export const ATP_ARCHIVE_NOT_STARTED = '0';
export const ATP_ARCHIVE_READY = '1';
export const ATP_ARCHIVE_ON_GOING = '2';
export const ATP_ARCHIVE_DONE = '3';

/*

  Order Statuses
 */
export const ORDER_PENDING = '0';
export const ORDER_ACCEPTED = '1';
export const ORDER_REJECTED = '2';

/*
  Transfer Statuses
 */
export const TRANSFER_PENDING_SUBMISSION = '0';
export const TRANSFER_PENDING_CONFIRMATION = '1';
export const TRANSFER_PENDING_PDTC_PROCESSING = '2';
export const TRANSFER_COMPLETED = '3';
export const TRANSFER_REJECTED = '4';
export const TRANSFER_REJECTED_FOR_EDIT = '5';

/*
 Investor Registration Statuses
 */
export const REGISTRATION_PENDING_SUBMISSION = '0';
export const REGISTRATION_PENDING_CONFIRMATION = '1';
export const REGISTRATION_PENDING_PDTC_PROCESSING = '2';
export const REGISTRATION_BP_ASSIGNED = '3';
export const REGISTRATION_REJECTED = '4';
export const REGISTRATION_CANCELLED = '5';

/*
  Term Sheet Statuses
 */
export const TERM_SHEET_DRAFT = '0';
export const TERM_SHEET_SUBMITTED = '1';
export const TERM_SHEET_CONFIRMED = '2';
export const TERM_SHEET_REJECTED = '3'

/*
  Coupon Types
 */
export const COUPON_TYPE_DISCOUNT = 'DISCOUNT';
export const COUPON_TYPE_FIXED = 'FIXED';
export const COUPON_TYPE_FLOATING = 'FLOATING';
export const COUPON_TYPE_STEPPED = 'STEPPED';

/*
  Coupon Frequency
 */
export const COUPON_FREQUENCY_ZERO = 'ZERO';
export const COUPON_FREQUENCY_MONTHLY = 'MONTHLY';
export const COUPON_FREQUENCY_QUARTERLY = 'QUARTERLY';
export const COUPON_FREQUENCY_SEMIANNUAL = 'SEMI-ANNUAL';
export const COUPON_FREQUENCY_ANNUAL = 'ANNUAL';
export const COUPON_FREQUENCY_OTHERS = 'OTHERS';

/*
  Authentication error messages
 */
export const AUTH_INVALID_USERNAME = "Please enter a valid username.";
export const AUTH_INVALID_PASSWORD = "Please enter a valid password.";
export const AUTH_INVALID_CODE = "Please enter a valid otp.";

/*
  Authentication success messages
 */
export const AUTH_SEND_CODE_SUCCESS = "Successfully sent verification code to registered email.";
export const AUTH_FORGOT_PASSWORD_SUCCESS = "Successfully changed your password.";

/*
  Invite investor messages
 */
export const INVITE_INVESTOR_SUCCESS = "Successfully invited applicant.";
export const BATCH_INVITE_INVESTOR_SUCCESS = "Successfully uploaded applicants.";
export const INVITE_INVESTOR_INVALID_EMAIL = "Invalid email address.";
export const BATCH_INVITE_INVESTOR_ERROR = "Something went wrong. Batch upload failed. Please contact system administrator.";

/*
  Order confirmation messages
 */
export const ORDER_ACCEPT_SUCCESS = "Reservation has been accepted."
export const ORDER_BULK_ACCEPT_SUCCESS = "Reservations have been accepted."
export const ORDER_REJECT_SUCCESS = "Reservation has been rejected."
export const ORDER_BULK_REJECT_SUCCESS = "Reservations have been rejected."
export const ORDER_CONFIRM_ERROR = "Reservation confirmation encountered a problem.  Please contact system administrator."
export const ORDER_SCALE_DOWN_INVALID = "Invalid reservation amount placed.";
export const ORDER_SCALE_DOWN_WRONG_INCREMENT = "Wrong increment.";
export const ORDER_SCALE_DOWN_LESS_MINIMUM = "Less than the designated minimum amount.";
export const ORDER_SCALE_DOWN_ABOVE = "Above initial amount placed.";
export const ORDER_ALLOCATION_EXCEEDED_ERROR = "You have exceeded the maximum allocation for this security."
export const ORDERS_SUBMIT_SUCCESS = "Sales report has been submitted for authorization.";
export const ORDERS_SUBMIT_ERROR = "Sales report submission encountered a problem.  Please contact system administrator";
export const SECURITY_AUTHORIZE_SUCCESS = "Sales report has been authorized and sent to PDTC Registry";
export const SECURITY_AUTHORIZE_ERROR = "Sales report authorization encountered a problem.  Please contact system administrator";
export const SECURITY_REJECT_SUCCESS = "Sales report has been rejected.";
export const SECURITY_REJECT_ERROR = "Sales report rejection encountered a problem.  Please contact system administrator";

/*
  Transfer confirmation messages
 */
export const TRANSFER_INSTRUCTION_SUCCESS = "Transfer Instruction sent to bond holder.";
export const TRANSFER_INSTRUCTION_ERROR = "Transfer Instruction encountered a problem.  Please contact system administrator."
export const TRANSFER_CONFIRM_SUCCESS = "Transfer confirmed and sent to PDTC for completion.";
export const TRANSFER_CONFIRM_ERROR = "Transfer confirmation encountered a problem.  Please contact system administrator.";
export const TRANSFER_COMPLETE_SUCCESS = "Transfer completed.";
export const TRANSFER_COMPLETE_ERROR = "Transfer completion encountered a problem.  Please contact system administrator."
export const TRANSFER_REJECT_SUCCESS = "Transfer rejected.";
export const TRANSFER_REJECT_ERROR = "Transfer rejection encountered a problem.  Please contact system administrator.";

/*
  Registration confirmation messages
 */
export const INVESTOR_REGISTRATION_SUCCESS = "Investor Registration Application sent to bond holder.";
export const INVESTOR_REGISTRATION_ERROR = "Investor Registration Application encountered a problem.  Please contact system administrator."
export const REGISTRATION_CONFIRM_SUCCESS = "Investor Registration confirmed and sent to PDTC for completion.";
export const REGISTRATION_CANCELLED_SUCCESS = "Investor Registration cancelled.";
export const REGISTRATION_CONFIRM_ERROR = "Investor Registration confirmation encountered a problem.  Please contact system administrator.";
export const REGISTRATION_CANCELLED_ERROR = "Investor Registration cancellation encountered a problem.  Please contact system administrator.";
export const REGISTRATION_BP_ASSIGNED_SUCCESS = "Investor Registration completed.";
export const REGISTRATION_BP_ASSIGNED_ERROR = "Investor Registration completion encountered a problem.  Please contact system administrator."
export const REGISTRATION_REJECT_SUCCESS = "Investor Registration rejected.";
export const REGISTRATION_REJECT_ERROR = "Investor Registration rejection encountered a problem.  Please contact system administrator.";


/*
  Listing messages
 */
export const LISTING_UPLOAD_DOCUMENT_SUCCESS = "Successfully uploaded listing required document.";
export const LISTING_UPLOAD_DOCUMENT_ERROR = "Something went wrong. Upload failed. Please contact system administrator.";
export const LISTING_CONFIRM_SUCCESS = "Term Sheet confirmed.";
export const LISTING_CONFIRM_ERROR = "Term Sheet confirmation encountered a problem.  Please contact system administrator."
export const LISTING_REJECT_SUCCESS = "Term Sheet rejected.";
export const LISTING_REJECT_ERROR = "Term Sheet rejection encountered a problem.  Please contact system administrator.";
export const LISTING_REVISE_OFFER_SIZE_SUCCESS = "Successfully revised security offer amount."
export const LISTING_REVISE_OFFER_SIZE_ERROR = "Security offer amount revision encountered a problem. Please contact system administrator."
export const LISTING_REVISE_AO_SUCCESS = "Successfully revised security amount outstanding."
export const LISTING_REVISE_AO_ERROR = "Security offer amount outstanding revision encountered a problem. Please contact system administrator."
export const LISTING_REVISE_ALLOCATION_SUCCESS = "Successfully revised participant allocation."
export const LISTING_REVISE_ALLOCATION_ERROR = "Participant allocation revision encountered a problem. Please contact system administrator."

/*
 System error messages
 */
export const GENERIC_ERROR = "There seems to be a problem. Contact system administrator.";
export const IDLE_SESSION = "You have been logged out due to inactivity."
/*
  REGEX PATTERNS
*/
export const PATTERN_TENOR = /^[a-z\.\d\-_\s]+$/i;
export const PATTERN_COUPON_RATES = /^[a-z\.,\-%\(\)\d\-\s]+$/i;

export const PATTERN_ALPHA_SPACE = /^[ A-Za-z]+$/;
export const PATTERN_ALPHA_NUMERIC_SPACE = /^[a-z\d\-_\s]+$/i;
export const PATTERN_ALPHA_NUMERIC = /^[a-z\d]+$/i
export const PATTERN_ALPHA_NUMERIC_SPACE_DOT = /^[a-z\d.\-_\s]+$/i;
export const PATTERN_NUMBER_4_DECIMAL = /^\d+(\.\d+)*$/;

/*
Security Type
*/
export const SECURITY_CLASS_DIGITAL = '1';


